/* Copyright 2013 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the properties associated with it.
 * A property can be marked as required and a default value can also be assigned to it.
 */

define([
    "../constants/TypeConstants"
],
    function (TypeConstants) {
        return [
            TypeConstants.TOOLSTRIP,
            TypeConstants.QAB,
            TypeConstants.QA_GROUP,
            TypeConstants.TAB_GROUP,
            TypeConstants.TAB,
            TypeConstants.SECTION,
            TypeConstants.COLUMN,
            TypeConstants.PANEL,
            TypeConstants.EMPTY_CONTROL,
            TypeConstants.POPUP_LIST,
            TypeConstants.POPUP_LIST_PANEL,
            TypeConstants.POPUP_LIST_HEADER,
            TypeConstants.POPUP_LIST_SEPARATOR,
            TypeConstants.FOOTER,
            TypeConstants.FOOTER_CELL,
            //Gallery:
            TypeConstants.GALLERY_POPUP,
            TypeConstants.GALLERY_FAVORITE_CATEGORY
        ];
    });